export default __webpack_public_path__ + "static/george-59321b931afd277e156e2ca6d595fd2b.png";